import { useApiClient } from '~/api-client';
import { CautionsTabResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { TAB_QUERY_CACHE_TIME } from '../tabs/constants';

export function useEventLocationCautionsQuery(props: { eventId?: number }) {
    const apiClient = useApiClient();
    const eventMetadata = useEventMetadataStore().state.metadata;
    // Use this as an indication that the location for the event has changed,
    // and reload cautions
    const eventCoordinates = [
        eventMetadata?.eventLocationLatitude,
        eventMetadata?.eventLocationLongitude,
    ].join(',');

    const query = useQuery(
        ['GetLocationCautions', props.eventId, eventCoordinates] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CautionsTabResource.GetLocationCautions>({
                    method: 'GET',
                    url: `cautions_tab/${queryKey[1]}/locations`,
                })
                .then((data) => {
                    return data.data.data;
                });
        },
        {
            cacheTime: TAB_QUERY_CACHE_TIME,
            enabled: !!props.eventId,
            refetchInterval(data) {
                const continuePolling = data?.continuePolling;
                return continuePolling || !data ? 5000 : false;
            },
        }
    );

    useEffect(() => {
        const { isLoading, refetch } = query;

        if (isLoading && !!props.eventId) {
            refetch();
        }
    }, [props.eventId, query]);

    return query;
}
